import createIcon from '../../createIcon';

/**
 * @component @name FindInPage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTkuNTlWOEwxNCAySDZDNC45IDIgNC4wMSAyLjkgNC4wMSA0TDQgMjBDNCAyMS4xIDQuODkgMjIgNS45OSAyMkgxOEMxOC40NSAyMiAxOC44NSAyMS44NSAxOS4xOSAyMS42TDE0Ljc2IDE3LjE3QzEzLjk2IDE3LjY5IDEzLjAyIDE4IDEyIDE4QzkuMjQgMTggNyAxNS43NiA3IDEzQzcgMTAuMjQgOS4yNCA4IDEyIDhDMTQuNzYgOCAxNyAxMC4yNCAxNyAxM0MxNyAxNC4wMiAxNi42OSAxNC45NiAxNi4xNyAxNS43NUwyMCAxOS41OVpNOSAxM0M5IDE0LjY2IDEwLjM0IDE2IDEyIDE2QzEzLjY2IDE2IDE1IDE0LjY2IDE1IDEzQzE1IDExLjM0IDEzLjY2IDEwIDEyIDEwQzEwLjM0IDEwIDkgMTEuMzQgOSAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FindInPage = createIcon('FindInPage', [
  [
    'path',
    {
      d: 'M20 19.59V8L14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C18.45 22 18.85 21.85 19.19 21.6L14.76 17.17C13.96 17.69 13.02 18 12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8C14.76 8 17 10.24 17 13C17 14.02 16.69 14.96 16.17 15.75L20 19.59ZM9 13C9 14.66 10.34 16 12 16C13.66 16 15 14.66 15 13C15 11.34 13.66 10 12 10C10.34 10 9 11.34 9 13Z',
      key: '1qhrnx',
    },
  ],
]);

export default FindInPage;
